import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Emergency } from './emergency.model';

const axios = useAxios();

export interface EmergencyService {
  Fetch: () => Promise<AxiosResponse<Emergency[]>>;
}

const Fetch = (): Promise<AxiosResponse<Emergency[]>> => axios.Get<Emergency[]>('/api/emergencies');

export default { Fetch } as EmergencyService;
